module.exports = __webpack_public_path__ + "static/best_relationship_fall_2023-7198ef1c4b11f1a77c02d2cad6206f27.svg";